export const SET_CALENDAR_LOCALE_PARAMS = 'SET_CALENDAR_LOCALE_PARAMS';

const paramsStore = {
  namespaced: true,
  state: {
    calendarLocaleParams: {}
  },
  getters: {
    calendarLocaleParams: state => state.calendarLocaleParams
  },
  mutations: {
    [SET_CALENDAR_LOCALE_PARAMS] (state, val) {
      state.calendarLocaleParams = val;
    }
  },
  actions: {
    [SET_CALENDAR_LOCALE_PARAMS] (context, val) {
      context.commit(SET_CALENDAR_LOCALE_PARAMS, val);
    }
  }
};

export default paramsStore;
